// extracted by mini-css-extract-plugin
export default {"title-caption":"style_title-caption__ijBoC","level":"style_level__Uz9Rq","text-wrapper":"style_text-wrapper__BwkZM","icons-1":"style_icons-1__5onjg","div":"style_div__8zDbc"};